import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginStart, loginSuccess, loginFailure, logout } from '../redux/authSlice';
import { useNavigate } from 'react-router-dom';
import { globals, authent_form, two_factors_form, getConnectedUser, _cookie_name} from '../Components/Globals/Globals';

import { loadStats, revertAllStats } from '../redux/statSlice';
import { loadArticles, revertAllArticles } from '../redux/articleSlice';
import { loadBlogs, revertAllBlogs } from '../redux/blogSlice';
import { loadHirings, revertAllHirings } from '../redux/hiringSlice';
import {loadAwards, revertAllAwards} from "../redux/awardSlice"
import {loadToolboxPartners, revertAllToolboxPartners} from "../redux/toolboxPartnerSlice"
import {loadVideos, revertAllVideos} from "../redux/videoSlice"
import {loadParams, revertAllParams} from "../redux/paramSlice"
import {loadHotels, revertAll} from "../redux/hotelSlice"



import {DsAdminAuthent} from "datasync-admin-authent"
import { openModal } from '../redux/modalSlice';

// reactstrap components
import {Button,Card,CardTitle,Container,Row,Col,} from "reactstrap";  

const LoginView = () => {
    const [uniquePage, setUniquePage] = useState(false)

    const fake_user = {"version":"Debug","current_user":{"data_guid":"98cabcb6-7f44-4b6c-94bc-1e95c27b9837",data_blob:{data_tier:{"e_mail":"pmabiala@me.com", "admin":"Oui"}}}}
    let {isAuthenticated} = useSelector((state) => state.auth);
    let {loadStats_result} = useSelector((state) => state.stats);
    let {loadArticles_result} = useSelector((state) => state.articles);
    let {loadBlogs_result} = useSelector((state) => state.blogs);
    let {loadHirings_result} = useSelector((state) => state.hirings);
    let {loadAwards_result} = useSelector((state) => state.awards);
    let {loadToolboxPartners_result} = useSelector((state) => state.toolbox);
    let {loadVideos_result} = useSelector((state) => state.video);
    let {loadParams_result} = useSelector((state) => state.params);
    let {loadHotels_result} = useSelector((state) => state.hotels);

    const dispatch = useDispatch();
    let navigate = useNavigate();

    React.useEffect(() => {
        let isMounted = true

        var navigationType = (window.performance.getEntriesByType("navigation")[0]).type;
        //back_forward value is duplicate tab
        if(navigationType == 'back_forward'){
            console.log("Login-page is duplicated")
            setUniquePage(false)
            
            window.open("https://www.lecercle-hotels.com/adh%C3%A9rer-nousrejoindre", "_self")
            alert ("L'admin HotelHub 360 est déjà ouverte dans ce navigateur ! Vous serez redirigés vers Le Cercle...")
        }
        else setUniquePage(true)

        //Automatically redirect to Admin console page as all data are loaded
        if (
            isAuthenticated 
            && loadStats_result.status == "succeeded"
            && loadArticles_result.status == "succeeded"
            && loadBlogs_result.status == "succeeded"
            && loadHirings_result.status == "succeeded"
            && loadAwards_result.status == "succeeded"
            && loadToolboxPartners_result.status == "succeeded"
            && loadVideos_result.status == "succeeded"
            && loadParams_result.status == "succeeded"
            && loadHotels_result.status == "succeeded"
        ){
            //Loading is done, the redirect to the landing page
            if (globals.parameters.debugging)
                console.log("LoginView.js::loading done...")
            navigate("/stats-page");
        }

        // If status is !loading, then fetch partners data from the API
        if (isAuthenticated && loadStats_result.status === 'idle'){
            if (globals.parameters.debugging)
                console.log("LoginView::Loading stats...")
            dispatch(loadStats());
        }

        if (isAuthenticated && loadArticles_result.status === "idle"){
            if (globals.parameters.debugging)
                console.log("LoginView::Loading articles...")
            dispatch(loadArticles());
        }

        if (isAuthenticated && loadBlogs_result.status === "idle"){
            if (globals.parameters.debugging)
                console.log("LoginView::Loading articles...")
            dispatch(loadBlogs());
        }

        if (isAuthenticated && loadHirings_result.status === "idle"){
            if (globals.parameters.debugging)
                console.log("LoginView::Loading hirings...")
            dispatch(loadHirings());
        }

        if (isAuthenticated && loadAwards_result.status === "idle"){
            if (globals.parameters.debugging)
                console.log("LoginView::Loading hotels awards...")
            dispatch(loadAwards());
        }

        if (isAuthenticated && loadToolboxPartners_result.status === "idle"){
            if (globals.parameters.debugging)
                console.log("LoginView::Loading toolbox partners...")
            dispatch(loadToolboxPartners());
        }

        if (isAuthenticated && loadVideos_result.status === "idle"){
            if (globals.parameters.debugging)
                console.log("LoginView::Loading video...")
            dispatch(loadVideos());
        }

        if (isAuthenticated && loadParams_result.status === "idle"){
            if (globals.parameters.debugging)
                console.log("LoginView::Loading params...")
            dispatch(loadParams());
        }

        if (isAuthenticated && loadHotels_result.status === "idle"){
            if (globals.parameters.debugging)
                console.log("LoginView::Loading hotels...")
            dispatch(loadHotels());
        }
            
        // Cleanup function
        return () => {
            isMounted = false
        }
    }, [isAuthenticated, dispatch, loadStats_result, loadArticles_result,loadBlogs_result, loadHirings_result, loadAwards_result, loadToolboxPartners_result, loadVideos_result]);
  
    const ErrMsg = (p_int_err_code) => {
        try{
            return globals.error_message[`code_${p_int_err_code}`]
        }
        catch(e){
            return "Erreur survenue"
        }
    }
    const authentMessage = (p_int_admin_authent_err_code) => {
        if (p_int_admin_authent_err_code == 100 || p_int_admin_authent_err_code == 101) return; // Don't care silent error
        try{
            if(globals.debugging) console.log(`authentMessage(${p_int_admin_authent_err_code})`)
            alert(globals.error_message[`code_${p_int_admin_authent_err_code}`])
        }
        catch(e){
            console.error(`authentMessage(${p_int_admin_authent_err_code}) raises ${e}`)
            alert("Erreur survenue à l'authentificiation")
        }
    }

    const onAdminCancelHandler = () => {
        dispatch(loginFailure(ErrMsg()));//Call reducer
        if (globals.parameters.debugging){
            console.log("onAdminCancelHandler");
        }
    }

    const onAdminFailsHandler = (p_error_object) => {
        dispatch(loginFailure(ErrMsg(p_error_object.code)));//Call reducer
        if (globals.parameters.debugging){
            console.log("onAdminFailsHandler p_error_object:", p_error_object);
        }

        authentMessage(p_error_object.code)
    }

    const onAdminDeniedHandler = (denied_user_object) => {
        dispatch(loginFailure(ErrMsg(denied_user_object)));//Call reducer
        if (globals.parameters.debugging){
            console.log("onAdminDeniedHandler denied_user_object:", denied_user_object);
        }

        //Don't care alert(`Admin user denied => ${JSON.stringify(denied_user_object)}`)
    }

    const onAdminConnectedHandler = (p_current_user) => {
        dispatch(loginSuccess(p_current_user));//Call reducer
        
        if (globals.parameters.debugging){
            console.log("19:Admin connecté",p_current_user)
            console.log("08:onAdminConnectHandler::p_current_user:", p_current_user);
        }

        navigate("/stats-page")
    }

    
    //rendering
    return (
        <div className="wrapper">
            {/* Full width main picture */}            
            {uniquePage &&
            <div
                className="page-header"
                style={{
                    backgroundImage:
                    "url(" + `${globals.dico.login_background_picture}` + ")",
                }}
                >

                <div className="filter" />
                    <Container>
                        <Row>
                            <Col className="ml-auto mr-auto" lg="8" md="10" sm="10">   
                                <Card className="card-register-two-factors">
                                        {/** Welcome state */}
                                        <CardTitle tag="h3">Bienvenue</CardTitle>
                                        <p>Sur <b>HotelHub 360</b>, utilisez votre compte administrateur <strong>Hotels.immo</strong> pour vous y connecter.</p>
                                        
                                    {/** Sign-in account form */}
                                    {(!isAuthenticated) && <>
                                        <div className="introduction-container">
                                            <p>Veuillez entrer vos informations de Connexion</p>
                                        </div>
                                        
                                        <DsAdminAuthent 
                                            //email_user_field = {""}
                                            obsolete_filter_format = {false}
                                            datasync_url = {globals.datasync_service.url}

                                            mailsync_url = {globals.mailsync.url}
                                            //token_email_display_sender = "ne_pas_repondre@plateform.marketplace-hotels.com"
                                            //token_email_display_sender = "ne_pas_repondre@hotels.immo"
                                            token_email_display_sender = "ne_pas_repondre@marketplace-hotels.com"
                                            company_guid={globals.datasync.h_immo_company_guid}
                                            table_guid={globals.datasync.h_immo_user_table_guid}
                                            onAdminGranted={(record)=>{onAdminConnectedHandler(record);}}
                                            beforeAdminGranted = {(p_o_user)=>{
                                                if (globals.parameters.debugging)
                                                    alert(`beforeAdminGranted => ${JSON.stringify(p_o_user)}`);  
                                                try {
                                                    return (p_o_user.data_blob.data_tier.validation === "Oui")}
                                                catch(e){
                                                    return false
                                                }
                                                }}
                                            onAdminCancelled={()=>{onAdminCancelHandler();}}
                                            onAdminFailed = {(p_error_object) => onAdminFailsHandler(p_error_object)} //An error occurs
                                            onAdminDenied = {(denied_user_object)=> onAdminDeniedHandler(denied_user_object)} //User is denied/> 
                                            onSendAlert={(target_email) => {dispatch(openModal({title:`Un courriel vous a été transmis à l'adresse ${target_email}`}))}}/>   
                                    </>}
                                </Card>
                                
                                {isAuthenticated && 
                                <div className="loading-container">
                                    <div className="loading-spinner">
                                        <div className="loading-spinner-inner"></div>
                                    </div>
                                    <div className="loading-text">Chargement...</div>
                                    <div className="loading-text">loadStats_result : {loadStats_result.status}</div>
                                    <div className="loading-text">loadArticles_result : {loadArticles_result.status}</div>                                        
                                    <div className="loading-text">loadHirings_result : {loadHirings_result.status}</div>                                        
                                </div>}
                            </Col>
                        </Row>
                        <div className="demo-footer text-center">
                        <h6>
                            {globals.dico.copyright}
                        </h6>
                        </div>
                    </Container>
            </div>}
            {globals.parameters.debugging &&
            <>
                <Button onClick={()=>{dispatch(loginSuccess(fake_user));}}>Connect</Button>
                <Button onClick={()=>{dispatch(logout());dispatch(revertAll()); dispatch(revertAllStats());dispatch(revertAllArticles());dispatch(revertAllBlogs);dispatch(revertAllHirings());dispatch(revertAllAwards()); dispatch(revertAllToolboxPartners());dispatch(revertAllVideos());dispatch(revertAllParams())}}>DisConnect</Button>
                <Button onClick={()=>{dispatch(openModal({title:"Bonjour Pat", message:"How are you my friend ?"}));}}>Ok Dialog</Button>
                <Button onClick={()=>{dispatch(openModal({title:"Are you agree Pat ?", okCallBack:(DialogObject)=>{alert("Ok pushed !")}, cancelCallBack:(DialogObject)=>{alert("Cancel pushed !")}}));}}>Confirm Dialog</Button>
                
            </>}
        </div>
        );
}

export default LoginView;